import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const MediaItem = ({ item, index, type, onRemove }) => {
  const [hasError, setHasError] = useState(false);
  
  // Function to validate URL and handle different formats
  const getImageSrc = (url) => {    
    // If it's an empty string or null/undefined, use SVG placeholder
    if (!url) {
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Crect width='80' height='80' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='10' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3EGörsel Yok%3C/text%3E%3C/svg%3E";
    }
    
    // Check if it's a YouTube URL and return thumbnail
    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      return getVideoThumbnail(url);
    }
    
    // If it's already an absolute URL, return as is
    if (url.startsWith('http')) {
      return url;
    }
    
    // If it's a relative URL starting with /uploads, use API URL
    if (url.startsWith('/uploads')) {
      const fullUrl = `${process.env.REACT_APP_API_URL}${url}`;
      return fullUrl;
    }
    
    // Otherwise, treat as a relative path
    return url;
  };

  return (
    <Box 
      sx={{ 
        position: 'relative', 
        width: 80, 
        height: 80 
      }}
    >
      <Box 
        component="img" 
        src={getImageSrc(item)}
        sx={{ 
          width: '100%', 
          height: '100%', 
          objectFit: 'cover',
          borderRadius: 1,
          filter: hasError ? 'grayscale(100%)' : 'none',
          opacity: hasError ? 0.3 : 1
        }} 
        onError={(e) => { 
          setHasError(true);
          e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='80' height='80' viewBox='0 0 80 80'%3E%3Crect width='80' height='80' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' font-family='Arial' font-size='10' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3EGörsel Yok%3C/text%3E%3C/svg%3E";
        }}
      />
      {hasError && (
        <Box 
          sx={{ 
            position: 'absolute', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.1)',
            borderRadius: 1
          }}
        >
          <Typography variant="caption" color="error" sx={{ textAlign: 'center', padding: '4px' }}>
            Hatalı Görsel
          </Typography>
        </Box>
      )}
      <IconButton
        size="small"
        sx={{ 
          position: 'absolute', 
          top: -10, 
          right: -10,
          bgcolor: 'rgba(255,255,255,0.8)',
          '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
        }}
        onClick={() => onRemove(type, index)}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

// Helper function for video thumbnails
const getVideoThumbnail = (url) => {
  // YouTube URL patterns
  const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(youtubeRegex);
  if (match) {
    // Use YouTube's thumbnail API
    return `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg`;
  }
  // Default thumbnail for non-YouTube videos or if ID extraction fails
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='70' viewBox='0 0 120 70'%3E%3Crect width='120' height='70' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='30%25' font-family='Arial' font-size='10' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3EVideo%3C/text%3E%3Ctext x='50%25' y='70%25' font-family='Arial' font-size='8' text-anchor='middle' dominant-baseline='middle' fill='%23999'%3E(Önizleme yok)%3C/text%3E%3C/svg%3E";
};

export default MediaItem;